<script lang="ts" setup>import { ref as _ref } from 'vue';

import { DotLottieVue, type DotLottieVueInstance } from '@lottiefiles/dotlottie-vue'
import animateCoins from './AnimateCoins.json?url'

const emit = defineEmits([
  'complete',
])

const playerRef = _ref<DotLottieVueInstance>()

onMounted(() => {
  if (playerRef.value) {
    const dotLottie = playerRef.value?.getDotLottieInstance()
    dotLottie?.addEventListener('complete', () => {
      emit('complete')
    })
  }
})

defineExpose({
  play: () => new Promise<void>((resolve) => {
    const dotLottie = playerRef.value?.getDotLottieInstance()
    dotLottie?.play()
    resolve()
  }),
  reset: () => {
    const dotLottie = playerRef.value?.getDotLottieInstance()
    dotLottie?.stop()
  },
})
</script>

<template>
  <div>
    <DotLottieVue
      ref="playerRef"
      style="height: 200px; width: 200px;"
      :autoPlay="false"
      :loop="false"
      :src="animateCoins"
    />

  </div>
</template>
